import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../services/api';

interface Job {
  id: string;
  title: string;
  description: string;
  // Add more fields as per your Job schema (e.g., company, location) from Technical Requirements
}

const ApplicantJobs: React.FC = () => {
  const api = useApi();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await api.get('/public-jobs'); // FIXED: Removed extra /api/ to match baseURL
        setJobs(response.data);
      } catch (err) {
        console.error('Error fetching jobs:', err);
        setError('Failed to load jobs. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, [api]);

  if (loading) return <div className="text-center py-8">Loading jobs...</div>;
  if (error) return <div className="text-center py-8 text-red-500">{error}</div>;

  return (
    <div className="min-h-screen bg-surface-page text-txt-primary p-8">
      <h1 className="text-3xl font-bold mb-6">Available Jobs</h1>
      <div className="mb-6 rounded-input border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
        <p className="font-semibold">Private preview</p>
        <p>These application links are for Jason testing only. Candidate Applications are not public or launched.</p>
      </div>
      {jobs.length === 0 ? (
        <p>No jobs available at the moment.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {jobs.map((job) => (
            <div key={job.id} className="bg-surface-card p-6 rounded-input shadow-md">
              <h2 className="text-xl font-semibold mb-2">{job.title}</h2>
              <p className="mb-4">{job.description.substring(0, 150)}...</p> {/* Truncate for preview */}
              <Link 
                to={`/jobs/${job.id}/apply`} 
                className="bg-brand-600 text-txt-primary px-4 py-2 rounded hover:bg-brand-700"
              >
                Apply Now
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ApplicantJobs;
